//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { checkDeferralAccess } from '../Report/ReportActions.js'
import WarningBanner from '../../components/WarningBanner.vue'

export default {
  name: 'CompleteWorksCard',
  components: {
    WarningBanner
  },
  props: {
    request: {
      type: Object,
      required: true
    },
    requestRoles: {
      type: Object,
      required: true
    },
    report: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      loading: false,
      selectedActionKey: 'fillReport',
      actions: [],

      hasAnotherAlreadyDeferredReport: false
    }
  },
  created: function () {
    this.loading = true
    checkDeferralAccess(this.report)
      .finally(() => {
        this.loading = false
      })
      .then(accessData => {
        this.hasAnotherAlreadyDeferredReport = !accessData.deferReport
      })

    const vm = this
    this.actions = [
      {
        key: 'fillReport',
        name: 'Заполнить отчёт',
        // descr: 'Заполнить отчёт и продолжить работу по другим заявкам',
        disabled: false
      },
      {
        key: 'deferReport',
        name: 'Отложить заполнение отчёта',
        descr: 'И продолжить работу по другим заявкам',
        // descr: 'Отложить заполнение отчёта и продолжить работу по другим заявкам',
        get disabled () {
          return vm.hasAnotherAlreadyDeferredReport
        }
      }
    ]
  },
  methods: {
    onActionSelected: function (action) {
      // if (this.selectedActionKey === action.key) {
      //   this.selectedActionKey = null
      // } else {
      this.selectedActionKey = action.key
    },
    onApply () {
      if (this.selectedActionKey == null) {
        return
      }

      this.$emit('apply', {
        deferReport: this.selectedActionKey === 'deferReport'
      })
    },
    onCancel () {
      this.$emit('cancel')
    }
  }
}
